import { render, staticRenderFns } from "./FilmSection.vue?vue&type=template&id=78569b23&scoped=true"
import script from "./FilmSection.vue?vue&type=script&lang=js"
export * from "./FilmSection.vue?vue&type=script&lang=js"
import style0 from "./FilmSection.vue?vue&type=style&index=0&id=78569b23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78569b23",
  null
  
)

export default component.exports